import classes from './FormTitle.module.css';
import { useTranslation } from 'react-i18next';
import TitleHeader from '../../Assets/TitleHeader/TitleHeader';

const FormTitle = () => {

    // Set translation
    const { t } = useTranslation();

    return (
        <div className={classes.formTitleContainer}>
            <TitleHeader
                headerText={t('formTitle.applicationTitle')}
            />
        </div>
    )
};

export default FormTitle;